import { useTranslation } from '@rhino-project/core/i18n';
import { useMemo } from 'react';

import { ModelCreateModal } from '@rhino-project/ui-heroui';
import { useFormContext } from 'react-hook-form';
import ExternalTeams from '../externalTeams/ExternalTeams';
import { ComponentProps } from 'react';

interface TeamSelectValues {
  external_linked_team: {
    external_team: number | string | null;
    external_team_season: number | string | null;
    team_name: string | null;
    season?: number | string | null;
  };
  [key: string]: unknown;
}

const ExternalTeamsWrapper = (props: Record<string, unknown>) => {
  const { t } = useTranslation();

  const { setValue } = useFormContext();

  const handleTeamSelect = (teamValues: TeamSelectValues) => {
    setValue('external_team', teamValues.external_linked_team.external_team);
    setValue(
      'external_team_season',
      teamValues.external_linked_team.external_team_season
    );
    setValue('team_name', teamValues.external_linked_team.team_name);
    setValue('season', teamValues.external_linked_team.season);
  };

  return (
    <ExternalTeams
      {...props}
      onlyTeamSeason={false}
      name="player_team"
      placeholder={t('frontend.messages.team')}
      teamValue={{}}
      onTeamSelect={handleTeamSelect}
    />
  );
};

const TeamHistoryModal = (props: ComponentProps<typeof ModelCreateModal>) => {
  const computedPaths = useMemo(() => {
    // eslint-disable-next-line @eslint-react/no-missing-key
    return [<ExternalTeamsWrapper />];
  }, []);

  return (
    <ModelCreateModal
      {...props}
      model="external_linked_team"
      paths={computedPaths}
    />
  );
};

export default TeamHistoryModal;
